<template>
  <div class="home text-white text-outline">
    <div class="home__header text-6xl">
      <div class="home__name p-24">John Pombo</div>
    </div>

    <div class="home__navigation">
      <div class="home__main-links italic text-6xl">
        <MainLink>Portfolio</MainLink>
        <MainLink>Kozo</MainLink>
        <MainLink>Hobbies</MainLink>
      </div>
      <div class="home__mini-links text-3xl">
        <div class="ml-12 label">Social Media</div>
        <div class="ml-12 label">E-Mail</div>
      </div>
    </div>

    <div class="home__display">Something goes here</div>
  </div>
</template>

<script>
import MainLink from "@/components/MainLink.vue";

export default {
  name: "Home",
  components: {
    MainLink
  }
};
</script>

<style lang="scss">
.home {
  text-shadow: -2px 0 black, 0 2px black, 2px 0 black, 0 -2px black;
  display: grid;
  grid-template-columns: 4fr 8fr;
  grid-template-areas:
    "header     header"
    "navigation display";

  &__header {
    grid-area: header;
    cursor: pointer;
  }

  &__navigation {
    grid-area: navigation;
    cursor: pointer;
  }

  &__display {
    grid-area: display;
    cursor: pointer;
  }
}
</style>
